import { pakkuIcon } from 'javascript/Constants'

export function getChatIconImageFromSettings(settings = {}) {
  return settings.en?.icon?.icon_image_url || pakkuIcon
}

export function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time))
}
